import React, { createContext, useContext } from 'react'

import {
  useNutrimaticMarketHub,
  type NutrimaticMarketHub,
} from './useNutrimaticMarketHub'

const NutrimaticMarketContext = createContext<NutrimaticMarketHub | null>(null)

/** App-wide Lab-style Nutrimatic hub (vitrina only — not swap/LP execution). */
export function NutrimaticMarketProvider({ children }: { children: React.ReactNode }) {
  const hub = useNutrimaticMarketHub()
  return (
    <NutrimaticMarketContext.Provider value={hub}>{children}</NutrimaticMarketContext.Provider>
  )
}

export function useNutrimaticMarket(): NutrimaticMarketHub {
  const ctx = useContext(NutrimaticMarketContext)
  if (!ctx) {
    throw new Error('useNutrimaticMarket must be used within NutrimaticMarketProvider')
  }
  return ctx
}

/** Optional access when a surface may render outside the provider (tests). */
export function useNutrimaticMarketOptional(): NutrimaticMarketHub | null {
  return useContext(NutrimaticMarketContext)
}
